"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MONTH_PAGE_WIDTH = exports.MONTHS_IN_YEAR = void 0;
exports.MONTHS_IN_YEAR = 12;
/** How much months to place in row on calendar page. */
exports.MONTH_PAGE_WIDTH = 3;
